
















import Vue from 'vue'
export default Vue.extend({
  name: 'SnackbarWrapper',
  props: {
    message: String,
    resolve: Function,
    showUndo: {
      type: Boolean,
      default: false
    },
    timeout: {
      type: Number,
      default: 5000
    }
  },
  data () {
    return {
      show: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.show = true
    })
    setTimeout(this.close, this.timeout)
  },
  methods: {
    close (undoButtonPressed = false) {
      this.resolve(undoButtonPressed)
      this.show = false
    }
  }
})
